import { CSSProperties, ReactNode } from 'react';
import Text from 'common/components/Text';
import Link from 'common/components/Link';
import Image from 'common/components/Image';

export interface LogoProps {
  href?: string;
  className?: string;
  /** Asset URL (string from Vite import). */
  logoSrc?: string;
  /** Title used as alt text or fallback content. */
  title?: string;
  /** Style props forwarded to the wrapping <Link>. */
  logoWrapperStyle?: Record<string, unknown>;
  /** Style props forwarded to the <Image>. */
  logoStyle?: Record<string, unknown>;
  /** Style props forwarded to the fallback <Text> when no logoSrc. */
  titleStyle?: Record<string, unknown>;
  withAnchor?: boolean;
  anchorProps?: Record<string, unknown>;
  children?: ReactNode;
  style?: CSSProperties;
}

const defaultLogoWrapperStyle: Record<string, unknown> = {
  display: 'inline-flex',
  alignItems: 'center',
  mr: '1rem',
  'a:hover,a:focus': { textDecoration: 'none' },
};

const defaultTitleStyle: Record<string, unknown> = {
  display: 'inline-block',
  fontSize: '2rem',
  lineHeight: 'inherit',
  whiteSpace: 'nowrap',
};

const Logo = ({
  logoWrapperStyle = defaultLogoWrapperStyle,
  logoStyle,
  titleStyle = defaultTitleStyle,
  withAnchor: _withAnchor,
  anchorProps: _anchorProps,
  logoSrc,
  title = '',
  ...props
}: LogoProps) => (
  <Link {...props} {...logoWrapperStyle}>
    <>
      {logoSrc ? (
        <Image src={logoSrc} alt={title} {...logoStyle} />
      ) : (
        <Text content={title} {...titleStyle} />
      )}
    </>
  </Link>
);

export default Logo;
